import { FC, ReactNode } from "react";
import Helmet from "react-helmet";
import { Box, Column, LogoutIcon } from "@hightouch/htui";
import { LinkButton } from "src/router";
import { useUser } from "src/contexts/user-context";
import grain from "src/assets/backgrounds/auth-grain.png";
import defaultBgImage from "src/assets/backgrounds/login.webp";

interface Props {
  bgImage?: string;
  children: ReactNode;
  metaTitle?: string;
}

export const AuthLayout: FC<Readonly<Props>> = ({
  children,
  metaTitle,
  bgImage = defaultBgImage,
}) => {
  const { user, isCompanyRequired } = useUser();

  const title = metaTitle ? `Hightouch | ${metaTitle}` : "Hightouch";

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Column
        align="center"
        justify="center"
        background={`url(${bgImage}), url(${grain}), var(--chakra-colors-base-background)`}
        backgroundPosition="center"
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
        h={{ base: "auto", lg: "100vh" }}
        minH="100vh"
        py={12}
        px={8}
        pos="relative"
        width="100vw"
        overflowY="auto"
      >
        {user && !isCompanyRequired && (
          <Box pos="absolute" right={4} top={4}>
            <LinkButton
              href={`${import.meta.env.VITE_API_BASE_URL}/auth/logout`}
              icon={LogoutIcon}
            >
              Logout
            </LinkButton>
          </Box>
        )}
        {children}
      </Column>
    </>
  );
};
